
import React from "react";
import "./Ribbon.css"; // Import the CSS file

import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { 
    faUser
} from '@fortawesome/free-solid-svg-icons';

const Ribbon = () => {
  return (
    <div className="container mt-6">
        <div className="row">
            <div className="col-lg-4">
                <div className="card">
                    <div className="card-block">
                      <div className="ribbon-container">
                        <div className="ribbon text-white">Ribbon</div>
                        <div className="content">
                          <div class="row mb-20">
                            <div class="col-auto">
                              <img class="img-50 rounded-circle p-0" alt="Profile" src="./profile.jpg" />
                            </div>
                            <div class="col">
                              <h5 class="m-0">Mukesh Kumar</h5>
                              <span class="m-0 f-12">Magento Developer</span>
                            </div>
                          </div>
                          <p class="f-14 m-0">Lorem ipsum dolor sit amet, consectetur adipisicing elit, sed do eiusmod tempor incididunt ut labore et dolore magna aliqua.</p>
                          <div className="row mt-4">
                            <div className="col-lg-4">
                              <FontAwesomeIcon icon={faUser} className="single-icon text-white" />
                              <h6 className="mt-2">Employees</h6>
                              <h6 className="">120</h6>
                            </div>
                            <div className="col-lg-4">
                              <FontAwesomeIcon icon={faUser} className="single-icon text-white" />
                              <h6 className="mt-2">Clients</h6>
                              <h6 className="">60</h6>
                            </div>
                            <div className="col-lg-4">
                              <FontAwesomeIcon icon={faUser} className="single-icon text-white" />
                              <h6 className="mt-2">Total</h6>
                              <h6 className="">180</h6>
                            </div>
                          </div>
                        </div>
                      </div>
                    </div>
                </div>
            </div>
            <div className="col-lg-4">
                <div className="card">
                    <div className="card-block">
                        <div className="ribbon-container">
                            <div className="ribbon-two">
                              <h6 className="mb-0 text-white">Special Offer!</h6>
                            </div>
                            <div className="content mt-5">
                              <h5>Welcome to Our Store</h5>
                              <p>Check out our exclusive deals and discounts.</p>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
            <div className="col-lg-4">
                <div className="card">
                    <div className="card-block ribbon-container overflow-hidden">
                        <div className="ribbon-3">
                            <span>Sale!</span>
                        </div>
                        <div className="content">
                            <h6>Product Title</h6>
                            <p>This is a product description. It's on sale!</p>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    </div>
  );
};

export default Ribbon;